import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "@/lib/utils";

function Tabs({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
    return (
        <TabsPrimitive.Root
            data-slot="tabs"
            className={cn("setu:flex setu:flex-col setu:gap-2", className)}
            {...props}
        />
    );
}

function TabsList({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.List>) {
    return (
        <TabsPrimitive.List
            data-slot="tabs-list"
            className={cn(
                "setu:bg-muted setu:text-muted-foreground setu:inline-flex setu:h-9 setu:w-fit setu:items-center setu:justify-center setu:rounded-lg setu:p-[3px]",
                className
            )}
            {...props}
        />
    );
}

function TabsTrigger({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
    return (
        <TabsPrimitive.Trigger
            data-slot="tabs-trigger"
            className={cn(
                "setu:data-[state=active]:bg-background dark:setu:data-[state=active]:text-foreground setu:focus-visible:!border-ring setu:focus-visible:ring-ring/50 setu:focus-visible:outline-ring dark:setu:data-[state=active]:!border-input dark:setu:data-[state=active]:bg-input/30 setu:text-foreground dark:setu:text-muted-foreground setu:inline-flex setu:h-[calc(100%-1px)] setu:flex-1 setu:items-center setu:justify-center setu:gap-1.5 setu:rounded-md setu:!border setu:!border-transparent setu:px-2 setu:py-1 setu:text-sm setu:font-medium setu:whitespace-nowrap setu:transition-[color,box-shadow] setu:focus-visible:ring-[3px] setu:focus-visible:outline-1 setu:disabled:pointer-events-none setu:disabled:opacity-50 setu:data-[state=active]:shadow-sm setu:[&_svg]:pointer-events-none setu:[&_svg]:shrink-0 setu:[&_svg:not([class*='size-'])]:size-4",
                className
            )}
            {...props}
        />
    );
}

function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
    return (
        <TabsPrimitive.Content
            data-slot="tabs-content"
            className={cn("setu:flex-1 setu:outline-none", className)}
            {...props}
        />
    );
}

export { Tabs, TabsList, TabsTrigger, TabsContent };
